import React, { useEffect, useState } from "react"
import Link from "next/link"
import Image from "next/image"
import logo from "../../public/images/BRONCO-White-logo.png"
import lightLogo from "../../public/images/logo-white.png"
import { useTheme } from "@/lib/context/ThemeContext"
export const Navbar = () => {

  const { isDarkMode } = useTheme()
  return (
    <div className="md:justify-normal justify-center flex w-full fixed p-7">
      <Link href={"/"}>
        <Image src={logo.src} alt="logo" width="414" height="100" className="" />
        {/* {
          isDarkMode === true ? (
          ) : (
            <Image src={lightLogo.src} alt="logo" width="214" height="50" />
          )
        } */}
      </Link>
    </div>
  )
}
